import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * @define new creator method for change
 */
import { v4 as uuidV4 } from 'uuid';
import * as ajax from '../ajax';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
import ga from '../../utils/ga';
import contentChangeActionFactory from './contentChangeActionFactory';
import changeActionFactory from './changeActionFactory';
import tokenErrorActions from '../tokenErrorActionCreators';
import notificationActions from '../notificationActionCreators';

/* eslint-disable-next-line default-param-last */
const uploadActionFactory = function uploadActionFactory(entity, entityRoute) {
  let useContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let trackingName = arguments.length > 3 ? arguments[3] : undefined;
  const constants = constantsRegistry(entity);
  const changeActions = useContent ? contentChangeActionFactory(entity, entityRoute) : changeActionFactory(entity, entityRoute);
  const uploadAll = files => ({
    type: constants.UPLOAD_ALL,
    filesToUpload: files
  });
  const uploadFailure = (file, errorText) => dispatch => {
    const message = "Failed to Upload File".concat(file.name ? " (".concat(file.name, ")") : '').concat(errorText ? ": ".concat(errorText) : '');
    // throw a failure notification up
    dispatch(notificationActions.error({
      rightButtonLabel: 'OK',
      message
    }));
    // log the file upload as a failure
    dispatch({
      type: constants.UPLOAD_FAILURE,
      error: message,
      file
    });
  };
  const uploadSuccess = file => ({
    type: constants.UPLOAD_SUCCESS,
    file
  });
  const serverSaving = (id, setStatus) => ({
    type: constants.SERVER_SAVE_STATUS,
    id,
    setStatus
  });

  // try saving the file details to the TQC server
  const serverSaveMedia = file => async (dispatch, getState) => {
    const url = "/".concat(entityRoute);
    try {
      // Grab the current state and check for any files that are actively being saved to the server
      const _getState$entity$pend = getState()[entity].pendingDocs,
        pendingDocs = _getState$entity$pend === void 0 ? [] : _getState$entity$pend;
      const otherFilesSaving = pendingDocs.some(nextFile => nextFile.savingToServer);

      // if there's already a file being saved to the server, wait for 100ms and try again
      if (otherFilesSaving) {
        setTimeout(() => dispatch(serverSaveMedia(file)), 100);
      } else {
        // If there's no file being actively saved to the server, set it's saveStatus
        // to active and go ahead and save to the server
        await dispatch(serverSaving(file.id, true));
        await ajax.post(url, file);
        await dispatch(serverSaving(file.id, false));
        dispatch(uploadSuccess(file));
      }
    } catch (e) {
      dispatch(tokenErrorActions.handleError(e, entity, uploadFailure.bind(_this, file, 'Upload failure'), serverSaveMedia.bind(_this, file)));
    }
  };
  const uploadOne = (incomingID, tmpKeyPath, saveKeyPath, file) => async dispatch => {
    const id = incomingID || file.id;
    if (!id) {
      dispatch(uploadFailure(null, 'No ID provided for entity'));
      return;
    }
    let fileRemotePath = file.remotePath;
    if (!file.remotePath && file.name) {
      // Create the remote path for saving in the db as well as on S3
      const ext = file.name.split('.')[file.name.split('.').length - 1];
      fileRemotePath = "".concat(uuidV4().toUpperCase(), ".").concat(ext);
    }
    const getUploadURL = '/files/uploadUrl';
    const getUploadData = {
      fileName: fileRemotePath,
      contentType: file.type
    };
    try {
      const getRes = await ajax.get(getUploadURL, getUploadData, 'text');
      // data for new entity can be stored under `file.rawFile` key, or plain `file`
      const fileToUpload = file.rawFile ? file.rawFile : file;
      const putUrl = getRes.data;
      await ajax.put(putUrl, fileToUpload, fileToUpload.type, 'text', false, false, false);
      ga.trackEntity('Upload', trackingName);
      dispatch(changeActions.change(id, saveKeyPath, file.remotePath));

      // if the file is not a pdf (ie png or jpg), handle retrieve the new download
      // URL from the server and save changes to the web app so the image can be displayed
      if (fileToUpload.type !== 'application/pdf') {
        // go get the new download url (now that it's uploaded)
        const getDownloadURL = '/files/downloadUrl';
        const getDownloadData = {
          fileName: file.remotePath
        };

        // Retrieve the S3 remote path for the newly uploaded image
        // (don't need this for PDFs, they aren't displayed on upload)
        const getDownRes = await ajax.get(getDownloadURL, getDownloadData, 'text');

        // Save the S3 remote path that was just retrieved back to content
        // so the image can be displayed
        await dispatch(changeActions.change(id, tmpKeyPath, getDownRes.data));
        dispatch(uploadSuccess(file));
      } else {
        // save the doc to the server - documentActions.serverSaveMedia
        // saving each file as it's uploaded allows repairPDF to scan, repair
        // and update the doc as soon as it's uploaded
        // serverSaveMedia calls uploadSuccess or uploadFailure as needed
        await dispatch(serverSaveMedia(file));
      }
    } catch (e) {
      // if the file failed to upload (likely due to expired token), try again (up to 2 more tries)
      dispatch(tokenErrorActions.handleError(e, entity, uploadFailure.bind(_this, file, 'Upload failure'), uploadOne.bind(_this, incomingID, tmpKeyPath, saveKeyPath, file)));
    }
  };
  const serverUpload = (incomingID, saveKeyPath, tmpKeyPath, filesToUpload) => async dispatch => {
    if (filesToUpload && filesToUpload.length) {
      dispatch(uploadAll(filesToUpload));
      try {
        // iterate the array of files, attempt to upload each individually
        await Promise.all(filesToUpload.map(file => dispatch(uploadOne(incomingID, tmpKeyPath, saveKeyPath, file))));
      } catch (e) {
        // files have already retried themselves up to 2 retries, calling it quits
        dispatch(uploadFailure.bind(_this, null, e.message));
      }
    }
  };
  const uploadClear = () => ({
    type: constants.UPLOAD_CLEAR
  });
  return _objectSpread(_objectSpread({}, changeActions), {}, {
    serverUpload,
    uploadAll,
    uploadFailure,
    uploadClear,
    uploadSuccess
  });
};
export default uploadActionFactory;